var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleCheckIcon16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-check-check",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6 7 17l-5-5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22 10-7.5 7.5L13 16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheckIcon16);
export default __webpack_public_path__ + "static/media/doubleCheckIcon16.9f5c32c35be8649d25802c8b05414c3e.svg";
export { ForwardRef as ReactComponent };